import { render, staticRenderFns } from "./TopBanHang.vue?vue&type=template&id=1415a98c&"
import script from "./TopBanHang.vue?vue&type=script&lang=js&"
export * from "./TopBanHang.vue?vue&type=script&lang=js&"
import style0 from "./TopBanHang.vue?vue&type=style&index=0&id=1415a98c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports